module.exports = __webpack_public_path__ + "img/icon-expand.36940c04.svg";